
export const fssItems = [
  {
    id: 'fss_1',
    text: {
      de: '"Ich fühle mich optimal beansprucht."',
      en: 'I feel just the right amount of challenge.'
    }
  },
  {
    id: 'fss_2',
    text: {
      de: '"Meine Gedanken bzw. Aktivitäten laufen flüssig und glatt."',
      en: 'My thoughts/activities run fluidly and smoothly.'
    }
  },
  {
    id: 'fss_3',
    text: {
      de: '"Ich merke gar nicht, wie die Zeit vergeht."',
      en: 'I don’t notice time passing.'
    }
  },
  {
    id: 'fss_4',
    text: {
      de: '"Ich habe keine Mühe, mich zu konzentrieren."',
      en: 'I have no difficulty concentrating.'
    }
  },
  {
    id: 'fss_5',
    text: {
      de: '"Mein Kopf ist völlig klar."',
      en: 'My mind is completely clear.'
    }
  },
  {
    id: 'fss_6',
    text: {
      de: '"Ich bin ganz vertieft in das, was ich gerade mache."',
      en: 'I am totally absorbed in what I am doing.'
    }
  },
  {
    id: 'fss_7',
    text: {
      de: '"Die richtigen Gedanken/Bewegungen kommen wie von selbst."',
      en: 'The right thoughts/movements occur of their own accord.'
    }
  },
  {
    id: 'fss_8',
    text: {
      de: '"Ich weiß bei jedem Schritt, was ich zu tun habe."',
      en: 'I know what I have to do each step of the way.'
    }
  },
  {
    id: 'fss_9',
    text: {
      de: '"Ich habe das Gefühl, den Ablauf unter Kontrolle zu haben."',
      en: 'I feel that I have everything under control.'
    }
  },
  {
    id: 'fss_10',
    text: {
      de: '"Ich bin völlig selbstvergessen."',
      en: 'I am completely lost in thought.'
    }
  },
  {
    id: 'fss_11',
    text: {
      de: '"Es steht etwas für mich Wichtiges auf dem Spiel."',
      en: 'Something important to me is at stake here.'
    }
  },
  {
    id: 'fss_12',
    text: {
      de: '"Ich darf jetzt keine Fehler machen."',
      en: 'I won’t make any mistake here.'
    }
  },
  {
    id: 'fss_13',
    text: {
      de: '"Ich mache mir Sorgen über einen Misserfolg."',
      en: 'I am worried about failing.'
    }
  },
]
